import { APIClient } from '../api_helper';
import { api } from '../../config';
import * as url from '../settings/url_helper';

import qs from 'qs';

const apiClient = new APIClient(api.REACT_APP_SPED_CORE_API_URL);

export const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Settings
export const getSettingsList = () => apiClient.get(url.GET_SETTINGS);
export const getSettings = settings =>
	apiClient.get(url.SETTINGS + '/' + encodeURIComponent(settings));
export const addNewSettings = settings =>
	apiClient.post(url.ADD_SETTINGS, settings);
export const updateSettings = settings =>
	apiClient.put(url.UPDATE_SETTINGS + '/' + settings._id, settings);
export const deleteSettings = settings =>
	apiClient.delete(url.DELETE_SETTINGS + '/' + settings._id);
export const baseSettingsColor = () => apiClient.post(url.BASE_SETTINGS_COLOR);
export const baseSettingsLogin = () => apiClient.post(url.BASE_SETTINGS_LOGIN);
export const baseSettingsHeader = () =>
	apiClient.post(url.BASE_SETTINGS_HEADER);

export const getModulesList = () => apiClient.get(url.GET_MODULES);
export const getModule = module_id =>
	apiClient.get(url.GET_MODULE + module_id);
export const addNewModule = module =>
	apiClient.post(url.ADD_MODULE, module);
export const updateModule = module =>
	apiClient.put(url.UPDATE_MODULE + '/' + module._id, module);
export const deleteModule = module =>
	apiClient.delete(url.DELETE_MODULE + '/' + module._id);

// Module Establishments
export const getModuleEstablishmentList = params => {
	return apiClient.get(
		`${url.GET_MODULE_ESTABLISHMENT}?${stringifyParams(params)}`
	);
};
export const getModuleEstablishment = params =>
	apiClient.get(
		`${url.MODULE_ESTABLISHMENT}/${params.module_id}/${params.establishment_id}`
	);
export const addNewModuleEstablishment = module_establishment =>
	apiClient.post(url.ADD_MODULE_ESTABLISHMENT, module_establishment);
export const updateModuleEstablishment = module_establishment =>
	apiClient.put(
		url.UPDATE_MODULE_ESTABLISHMENT + '/' + module_establishment._id,
		module_establishment
	);
export const deleteModuleEstablishment = module_establishment =>
	apiClient.delete(
		url.DELETE_MODULE_ESTABLISHMENT + '/' + module_establishment._id
	);

// Payment
export const getPaymentList = (params = {}) => {
	const limit = params.limit || 99999;
	const skip = params.skip || 0;
	const queryString = `limit=${limit}&skip=${skip}`;
	return apiClient.get(`${url.GET_PAYMENT}?${queryString}`);
};
export const getPayment = params =>
	apiClient.get(`${url.PAYMENT}/${params.payment_id}`);
export const addNewPayment = payment =>
	apiClient.post(url.ADD_PAYMENT, payment);
export const updatePayment = payment =>
	apiClient.put(url.UPDATE_PAYMENT + '/' + payment._id, payment);
export const deletePayment = payment =>
	apiClient.delete(url.DELETE_PAYMENT + '/' + payment._id);
export const setPaymentCancelled = payment =>
	apiClient.post(url.ADD_PAYMENT_CANCELLED + payment);
export const generatePayment = ({ month, year, category } = {}) =>
	apiClient.post(
		`${url.GENERATE_PAYMENT}?${stringifyParams({ month, year, category })}`
	);

export const previewPayment = ({ year, month, category } = {}) =>
	apiClient.get(
		`${url.PREVIEW_PAYMENT}?${stringifyParams({ year, month, category })}`
	);

export const calculateModuleUsageFact = ({ year, month } = {}) =>
	apiClient.post(
		`${url.CALCULATE_MODULE_USAGE_FACT}?${stringifyParams({ year, month })}`
	);

export const getModuleUsageFactList = (params = {}) =>
	apiClient.get(`${url.GET_MODULE_USAGE_FACT}?${stringifyParams(params)}`);
